import { Controller } from 'stimulus'
import $ from 'jquery'
import { haptics } from '~/common/helpers/haptics'

export default class extends Controller {
  static values = {
    productId: Number,
    priceId: Number,
  }

  // When we add a product to the cart, we could have 1 of 2 scenarios:
  // - This product IS NOT in the cart, or is in the cart but is able to increase the quantity:
  //   > We will increment the quantity, re-render the add to cart button, with the popover open
  // - There was an error with adding the product to the cart:
  //   > We will render an error message and try to update the cart counter/badge if needed.
  addToCart(event) {
    const { url, quantity, canAddMore, currencyCode } = event.params

    if (!canAddMore) {
      console.log('Can not add more')
      console.log(event)
      haptics.reject()
      return
    }

    $.sajax({
      url,
      method: 'POST',
      data: {
        quantity,
        product_id: this.productIdValue,
        price_id: this.priceIdValue,
        currency_code: currencyCode,
      },
      // Confirm only once the server has actually added it — a tap before the
      // response would buzz "success" even on a network/server failure.
      success: () => haptics.tap(),
    })
  }

  updateCartItemQuantity(event) {
    $.sajax({
      url: event.params.url,
      method: 'PATCH',
      data: {
        product_id: this.productIdValue,
        cart_item: {
          price_id: this.priceIdValue,
          quantity: event.target.value,
        },
      },
    })
  }
}
